export default {
    Category: {},
    Categories: [],
    TotalInfo: {
        count: 0,
        limit: 20,
        page: 1,
        rows: []
    },
}